import PlannerMap from 'core/js/pages/planner/direction-internal-result/_planner-map'

// Extiende el show del core y fuerza el layout extendido para GC
export default {
  extends: PlannerMap,
  template: PlannerMap.template,
  props: {
    ...PlannerMap.props,
    useExtendedLayout: {
      type: Boolean,
      default: true
    }
  }
}



